import { useState } from 'react';
import './ExpandableFilterPanel.css';

interface ExpandableFilterPanelProps {
  title?: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
}

const ExpandableFilterPanel: React.FC<ExpandableFilterPanelProps> = ({
  title = '篩選',
  children,
  defaultExpanded = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={`expandable-filter-panel ${isExpanded ? 'expandable-filter-panel--expanded' : ''}`}>
      <button
        className="expandable-filter-panel__toggle"
        onClick={() => setIsExpanded(!isExpanded)}
        type="button"
        aria-expanded={isExpanded}
      >
        <span className="expandable-filter-panel__toggle-text">
          {title}
        </span>
        <span className={`expandable-filter-panel__icon ${isExpanded ? 'expandable-filter-panel__icon--open' : ''}`}>
          ▼
        </span>
      </button>

      <div className="expandable-filter-panel__content">
        {children}
      </div>
    </div>
  );
};

export default ExpandableFilterPanel;
